import React from 'react';
import { mockAdBanners, mockRepairShops, mockCategories, mockListings } from '../../mockData';
import AdBannerSlider from '../home/AdBannerSlider';
import RepairShopPromo from '../home/RepairShopPromo';
import CategoryBrowser from '../home/CategoryBrowser';
import FeaturedListings from '../home/FeaturedListings';

function HomePage() {
  return (
    <div className="page home-page">
      {/* Ad Banner Slider Section */}
      <section className="home-section banner-section">
        <div className="container">
          <AdBannerSlider banners={mockAdBanners} />
        </div>
      </section>
      
      {/* Repair Shop Promo Section */}
      <section className="home-section repair-promo-section">
        <div className="container">
          <h2 className="section-title">Trusted Repair Shops</h2>
          <RepairShopPromo repairShops={mockRepairShops} />
        </div>
      </section>
      
      {/* Category Browser Section */}
      <section className="home-section category-section">
        <div className="container">
          <h2 className="section-title">Browse by Category</h2>
          <CategoryBrowser categories={mockCategories} />
        </div>
      </section>
      
      {/* Featured Listings Section */}
      <section className="home-section featured-section">
        <div className="container">
          <h2 className="section-title">Featured Listings</h2>
          <FeaturedListings listings={mockListings} />
        </div>
      </section>
    </div>
  );
}

export default HomePage; 